export default __webpack_public_path__ + "static/media/intro3.4894f95d.mp3";